import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8.638 11.296a.667.667 0 01-.471.196h-.338a.684.684 0 01-.47-.196l-4.56-4.569a.444.444 0 010-.631l.63-.631a.436.436 0 01.622 0L7.998 9.42l3.947-3.955a.444.444 0 01.63 0l.623.631a.444.444 0 010 .631l-4.56 4.569z" fill="#757a8a" /></svg>);